import { Timeline, Popover } from 'antd';
import React from 'react';
import { useSelector } from 'dva';
import { TooltipsStyled } from './TimeLineStyled';

const App = () => {
  // const list = [
  //   {
  //     label: '09:12:11',
  //     content: '登陆',
  //   },
  //   {
  //     label: '09:12:11',
  //     content: '登陆',
  //   },
  //   {
  //     label: '09:12:11',
  //     content: '登陆',
  //   },
  //   {
  //     label: '09:12:11',
  //     content: '登陆',
  //   },
  //   {
  //     label: '09:12:11',
  //     content: '登陆',
  //   },
  // ];
  const { trackingLogTrajectory } = useSelector((state) => state.userBehavior);
  const eventParams = (p) => {
    const jsonP = p ? JSON.parse(p) : {};
    const keys = Object.keys(jsonP)?.filter(
      (k) =>
        ![
          '_url',
          '_sessid',
          'g_dprefer',
          '_eventtime',
          'userid',
          'tenant_id',
        ].includes(k),
    );
    return keys?.map((k) => `${k}:${jsonP[k]}`).join(';');
  };
  const content = (data) => {
    const { url, eventTime, objectDesc, behaveOid, params } = data;

    return (
      <div
        style={{
          padding: '10px 6px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <div display="flex" mb={2.5}>
          事件详情
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#333',
            fontSize: '12px',
          }}
        >
          <span style={{ display: 'inline-block', width: '100px' }}>
            事件标识符
          </span>
          <span
            style={{
              display: 'inline-block',
              width: '200px',
              textAlign: 'right',
              wordWrap: 'break-word',
            }}
          >
            {behaveOid}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#333',
            fontSize: '12px',
          }}
        >
          <span style={{ display: 'inline-block', width: '100px' }}>
            事件发生时间
          </span>
          <span
            style={{
              display: 'inline-block',
              width: '200px',
              textAlign: 'right',
            }}
          >
            {eventTime}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#333',
            fontSize: '12px',
          }}
        >
          <span style={{ display: 'inline-block', width: '100px' }}>
            页面URL
          </span>
          <span
            style={{
              display: 'inline-block',
              width: '200px',
              wordWrap: 'break-word',
              textAlign: 'right',
            }}
          >
            {url}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#333',
            fontSize: '12px',
          }}
        >
          <span style={{ display: 'inline-block', width: '100px' }}>
            事件属性
          </span>
          <span
            style={{
              display: 'inline-block',
              width: '200px',
              wordWrap: 'break-word',
              textAlign: 'right',
            }}
          >
            {objectDesc}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: '#333',
            fontSize: '12px',
          }}
        >
          <span style={{ display: 'inline-block', width: '100px' }}>
            事件参数
          </span>
          <span
            style={{
              display: 'inline-block',
              width: '200px',
              wordWrap: 'break-word',
              textAlign: 'right',
            }}
          >
            {eventParams(params)}
          </span>
        </div>
      </div>
    );
  };
  return (
    <TooltipsStyled>
      <Timeline mode="left">
        {(trackingLogTrajectory || []).map((item, index) => (
          <Timeline.Item key={index} label={item.eventTime}>
            <div className="item">
              <Popover
                content={() => content(item)}
                trigger="hover"
                overlayClassName="p-wrap"
                getPopupContainer={() => document.getElementById('root')}
                // overlayStyle={{ width: '280px' }}
              >
                <div style={{ display: 'inline-block' }} className="item_text">
                  {item.behaveName}
                </div>
              </Popover>
            </div>
          </Timeline.Item>
        ))}
      </Timeline>
    </TooltipsStyled>
  );
};
export default App;
